module.exports = __webpack_public_path__ + "fonts/Inter-Thin.f341ca5.ttf";